{
	"title": "Διαθέσιμα υλικά",
	"showAllTitle": "Εμφάνιση όλων των υλικών",
	"table": {
		"material": "Υλικό",
		"invoicedQuantity": "Τιμολογημένη ποσότητα",
		"remainingForTransfer": "Απομένει για τη δημιουργία δήλωσης",
		"fetchError": "Δεν ήταν δυνατή η λήψη υλικών",
		"noMaterials": {
			"title": "Δεν υπάρχουν διαθέσιμα υλικά",
			"description": "Αυτήν τη στιγμή δεν έχετε διαθέσιμο υλικό στο {{productName}}. Επικοινωνήστε με τον αντιπρόσωπο πωλήσεών σας για να προσθέσετε τις συμβάσεις σας στον λογαριασμό σας."
		}
	}
}
